/* ============================================================
   VELEPRODAJA ODJECE - Theme JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  // ============================================================
  // MOBILE MENU
  // ============================================================
  const mobileMenuBtn = document.getElementById('mobile-menu-btn');
  const mobileMenuPanel = document.getElementById('mobile-menu-panel');
  const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
  const mobileMenuCloseBtn = document.getElementById('mobile-menu-close-btn');

  function openMobileMenu() {
    mobileMenuPanel && mobileMenuPanel.classList.add('open');
    mobileMenuOverlay && mobileMenuOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    mobileMenuPanel && mobileMenuPanel.classList.remove('open');
    mobileMenuOverlay && mobileMenuOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  mobileMenuBtn && mobileMenuBtn.addEventListener('click', openMobileMenu);
  mobileMenuCloseBtn && mobileMenuCloseBtn.addEventListener('click', closeMobileMenu);
  mobileMenuOverlay && mobileMenuOverlay.addEventListener('click', closeMobileMenu);

  // ============================================================
  // SEARCH OVERLAY
  // ============================================================
  const searchOpenBtn = document.getElementById('search-open-btn');
  const searchOverlay = document.getElementById('search-overlay');

  searchOpenBtn && searchOpenBtn.addEventListener('click', function() {
    searchOverlay && searchOverlay.classList.add('open');
    const input = searchOverlay && searchOverlay.querySelector('input');
    if (input) setTimeout(() => input.focus(), 100);
  });
  searchOverlay && searchOverlay.addEventListener('click', function(e) {
    if (e.target === searchOverlay) searchOverlay.classList.remove('open');
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      searchOverlay && searchOverlay.classList.remove('open');
      closeCartDrawer();
      closeMobileMenu();
    }
  });

  // ============================================================
  // CART DRAWER
  // ============================================================
  const cartOpenBtn = document.getElementById('cart-open-btn');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartCloseBtn = document.getElementById('cart-close-btn');

  function openCartDrawer() {
    cartDrawer && cartDrawer.classList.add('open');
    cartOverlay && cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    cartDrawer && cartDrawer.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  cartOpenBtn && cartOpenBtn.addEventListener('click', openCartDrawer);
  cartCloseBtn && cartCloseBtn.addEventListener('click', closeCartDrawer);
  cartOverlay && cartOverlay.addEventListener('click', closeCartDrawer);

  // ============================================================
  // ADD TO CART (Collection/Featured Products)
  // ============================================================
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.add-to-cart-btn[data-variant-id]');
    if (!btn) return;
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.textContent = 'Dodaje se...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      btn.textContent = '✓ Dodano!';
      btn.style.background = '#2d7a4f';
      updateCartCount();
      setTimeout(() => {
        btn.textContent = originalText;
        btn.style.background = '';
        btn.disabled = false;
        openCartDrawer();
        refreshCartDrawer();
      }, 1200);
    })
    .catch(() => {
      btn.textContent = 'Greška!';
      btn.style.background = '#c0392b';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.style.background = '';
        btn.disabled = false;
      }, 1500);
    });
  });

  // ============================================================
  // PRODUCT PAGE - Add to Cart Form
  // ============================================================
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const variantId = document.getElementById('variant-id').value;
      const qty = parseInt(document.getElementById('qty-input').value) || 1;
      const submitBtn = document.getElementById('add-to-cart-btn');

      submitBtn.textContent = 'Dodaje se...';
      submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(r => r.json())
      .then(() => {
        submitBtn.textContent = '✓ Dodano u košaricu!';
        submitBtn.style.background = '#2d7a4f';
        updateCartCount();
        setTimeout(() => {
          submitBtn.textContent = 'Dodaj u košaricu';
          submitBtn.style.background = '';
          submitBtn.disabled = false;
          openCartDrawer();
          refreshCartDrawer();
        }, 1500);
      })
      .catch(() => {
        submitBtn.textContent = 'Greška — pokušajte ponovo';
        submitBtn.style.background = '#c0392b';
        setTimeout(() => {
          submitBtn.textContent = 'Dodaj u košaricu';
          submitBtn.style.background = '';
          submitBtn.disabled = false;
        }, 2000);
      });
    });
  }

  // ============================================================
  // PRODUCT PAGE - Quantity Controls
  // ============================================================
  const qtyMinus = document.getElementById('qty-minus');
  const qtyPlus = document.getElementById('qty-plus');
  const qtyInput = document.getElementById('qty-input');

  qtyMinus && qtyMinus.addEventListener('click', function() {
    const val = parseInt(qtyInput.value) || 1;
    if (val > 1) qtyInput.value = val - 1;
  });
  qtyPlus && qtyPlus.addEventListener('click', function() {
    const val = parseInt(qtyInput.value) || 1;
    qtyInput.value = val + 1;
  });

  // ============================================================
  // PRODUCT PAGE - Variant Selection (Color & Size)
  // ============================================================
  const productData = window.__productData;

  if (productData) {
    // Color buttons
    document.querySelectorAll('.color-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.color-btn').forEach(b => b.classList.remove('selected'));
        this.classList.add('selected');
        const colorName = document.getElementById('selected-color-name');
        if (colorName) colorName.textContent = this.getAttribute('data-color');
        updateSelectedVariant();
      });
    });

    // Size buttons
    document.querySelectorAll('.size-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const optionIndex = this.getAttribute('data-option-index');
        document.querySelectorAll(`.size-btn[data-option-index="${optionIndex}"]`).forEach(b => b.classList.remove('selected'));
        this.classList.add('selected');
        const sizeName = document.getElementById('selected-size-name');
        if (sizeName) sizeName.textContent = this.getAttribute('data-size');
        updateSelectedVariant();
      });
    });

    function updateSelectedVariant() {
      const selectedColor = document.querySelector('.color-btn.selected');
      const selectedSize = document.querySelector('.size-btn.selected');

      const colorVal = selectedColor ? selectedColor.getAttribute('data-color') : null;
      const sizeVal = selectedSize ? selectedSize.getAttribute('data-size') : null;

      let matchedVariant = null;
      for (const variant of productData.variants) {
        const options = [variant.option1, variant.option2, variant.option3];
        const colorMatch = !colorVal || options.includes(colorVal);
        const sizeMatch = !sizeVal || options.includes(sizeVal);
        if (colorMatch && sizeMatch) {
          matchedVariant = variant;
          break;
        }
      }

      if (matchedVariant) {
        const variantIdInput = document.getElementById('variant-id');
        if (variantIdInput) variantIdInput.value = matchedVariant.id;

        // Update price
        const priceEl = document.getElementById('product-price');
        if (priceEl) {
          priceEl.textContent = formatMoney(matchedVariant.price);
        }

        // Update availability
        const addBtn = document.getElementById('add-to-cart-btn');
        if (addBtn) {
          if (matchedVariant.available) {
            addBtn.textContent = 'Dodaj u košaricu';
            addBtn.disabled = false;
            addBtn.style.background = '';
          } else {
            addBtn.textContent = 'Rasprodano';
            addBtn.disabled = true;
            addBtn.style.background = '#ccc';
          }
        }

        // Update image if variant has one
        if (matchedVariant.featured_image) {
          const mainImg = document.getElementById('gallery-main-img');
          if (mainImg) {
            mainImg.src = matchedVariant.featured_image.src;
          }
        }
      }
    }
  }

  // ============================================================
  // PRODUCT PAGE - Image Gallery
  // ============================================================
  const galleryImages = productData ? productData.images : [];
  let currentGalleryIndex = 0;

  const galleryMainImg = document.getElementById('gallery-main-img');
  const galleryPrev = document.getElementById('gallery-prev');
  const galleryNext = document.getElementById('gallery-next');
  const galleryCounter = document.getElementById('gallery-counter');
  const thumbs = document.querySelectorAll('.product-thumb');

  function setGalleryImage(index) {
    if (!galleryImages.length) return;
    currentGalleryIndex = (index + galleryImages.length) % galleryImages.length;
    if (galleryMainImg) {
      galleryMainImg.style.opacity = '0.7';
      galleryMainImg.src = galleryImages[currentGalleryIndex].src;
      galleryMainImg.onload = () => { galleryMainImg.style.opacity = '1'; };
    }
    if (galleryCounter) galleryCounter.textContent = `${currentGalleryIndex + 1} / ${galleryImages.length}`;
    thumbs.forEach((t, i) => t.classList.toggle('active', i === currentGalleryIndex));
  }

  galleryPrev && galleryPrev.addEventListener('click', () => setGalleryImage(currentGalleryIndex - 1));
  galleryNext && galleryNext.addEventListener('click', () => setGalleryImage(currentGalleryIndex + 1));
  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => setGalleryImage(i));
  });

  // Touch/swipe support
  let touchStartX = 0;
  galleryMainImg && galleryMainImg.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
  galleryMainImg && galleryMainImg.addEventListener('touchend', e => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) setGalleryImage(currentGalleryIndex + (diff > 0 ? 1 : -1));
  });

  // ============================================================
  // PRODUCT PAGE - Tabs
  // ============================================================
  document.querySelectorAll('.product-tab-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.product-tab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.product-tab-content').forEach(c => c.classList.remove('active'));
      this.classList.add('active');
      const tabId = 'tab-' + this.getAttribute('data-tab');
      const tabContent = document.getElementById(tabId);
      tabContent && tabContent.classList.add('active');
    });
  });

  // ============================================================
  // CART - Update Quantity & Remove
  // ============================================================
  document.addEventListener('click', function(e) {
    // Quantity buttons in cart
    const qtyBtn = e.target.closest('.cart-qty-btn');
    if (qtyBtn) {
      const key = qtyBtn.getAttribute('data-key');
      const action = qtyBtn.getAttribute('data-action');
      const qtySpan = qtyBtn.parentElement.querySelector('.cart-qty-num');
      const currentQty = parseInt(qtySpan ? qtySpan.textContent : 1);
      const newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
      updateCartItem(key, newQty);
    }

    // Remove button
    const removeBtn = e.target.closest('.cart-item-remove');
    if (removeBtn) {
      const key = removeBtn.getAttribute('data-key');
      updateCartItem(key, 0);
    }
  });

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(r => r.json())
    .then(() => {
      updateCartCount();
      refreshCartDrawer();
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const countEl = document.getElementById('cart-count');
        if (countEl) countEl.textContent = cart.item_count;
      });
  }

  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer-content', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(() => {
      // Reload page to refresh cart drawer content
      // For a full SPA experience, we'd use AJAX to update just the cart
      window.location.reload();
    })
    .catch(() => window.location.reload());
  }

  /* share cart - registered globally below */

/* ============================================================
   UTILITY: Format Money
   ============================================================ */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return amount.replace('.', ',') + ' KM';
  }

  // ============================================================
  // SWATCH HOVER on product cards - change image
  // ============================================================
  document.querySelectorAll('.product-card').forEach(card => {
    const swatches = card.querySelectorAll('.swatch-dot');
    const img = card.querySelector('.product-image-wrap img');

    swatches.forEach(swatch => {
      swatch.addEventListener('click', function(e) {
        e.preventDefault();
        swatches.forEach(s => s.classList.remove('active'));
        this.classList.add('active');
        // Navigate to variant URL
        const href = this.getAttribute('href');
        if (href && href !== '#') {
          // Don't navigate, just update visual
        }
      });
    });
  });

  // ============================================================
  // BOTTOM NAV - Active State
  // ============================================================
  const currentPath = window.location.pathname;
  document.querySelectorAll('.bottom-nav-item').forEach(item => {
    const href = item.getAttribute('href');
    if (href && href !== '#' && !href.startsWith('https')) {
      if (href === '/' ? currentPath === '/' : currentPath.startsWith(href)) {
        item.classList.add('active');
      }
    }
  });

  // ============================================================
  // ANNOUNCEMENT BAR - Auto-rotate
  // ============================================================
  const announcementSlides = document.querySelectorAll('.announcement-bar__slides span');
  if (announcementSlides.length > 1) {
    let currentSlide = 0;
    announcementSlides.forEach((s, i) => { if (i !== 0) s.style.display = 'none'; });
    setInterval(() => {
      announcementSlides[currentSlide].style.display = 'none';
      currentSlide = (currentSlide + 1) % announcementSlides.length;
      announcementSlides[currentSlide].style.display = 'inline';
    }, 4000);
  }

});

/* ============================================================
   SHARE CART VIA WHATSAPP — Global function
   Must be outside DOMContentLoaded so onclick="shareCartViaWhatsApp()" works
   ============================================================ */
function shareCartViaWhatsApp() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (!cart.items || cart.items.length === 0) {
        alert('Vaša košarica je prazna.');
        return;
      }

      var msg = '*Košarica — Veleprodaja Odjece*\n\n';
      cart.items.forEach(function(item) {
        var name = item.product_title || item.title;
        var variant = (item.variant_title && item.variant_title !== 'Default Title')
          ? ' (' + item.variant_title + ')' : '';
        var qty = item.quantity;
        var price = (item.final_line_price / 100).toFixed(2).replace('.', ',');
        msg += '• ' + name + variant + '\n  Količina: ' + qty + ' kom — ' + price + ' KM\n';
      });

      var total = (cart.total_price / 100).toFixed(2).replace('.', ',');
      msg += '\n*Ukupno: ' + total + ' KM*';
      msg += '\n\nLink na košaricu: ' + window.location.origin + '/cart';

      var waUrl = 'https://wa.me/38762130422?text=' + encodeURIComponent(msg);
      window.open(waUrl, '_blank');
    })
    .catch(function() {
      alert('Greška pri učitavanju košarice. Pokušajte ponovo.');
    });
}
